var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityFeed(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.713 15.39H4.701a.694.694 0 01-.7-.704V3.703A.704.704 0 014.7 3h8.012a.704.704 0 01.695.703v10.98a.702.702 0 01-.695.708zM6.631 9.583a.823.823 0 000 1.646h1.646a.823.823 0 000-1.646H6.63zm0-2.468a.823.823 0 100 1.645h4.114a.823.823 0 100-1.645H6.631zm0-2.47a.823.823 0 000 1.647h4.114a.823.823 0 100-1.646H6.631zm-.61 11.274h7.798a.329.329 0 00.329-.33V5.503a.325.325 0 01.649 0v10.085a.982.982 0 01-.98.981H6.02a.326.326 0 110-.65v-.002zm8.927 1.189H6.586a.352.352 0 000 .703h8.362A1.052 1.052 0 0016 16.758V5.947a.348.348 0 00-.696 0v10.811a.352.352 0 01-.356.349z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityFeed);
export default ForwardRef;